module.exports = __webpack_public_path__ + "img/ review.14cec487.png";